import FactoryComponents from '../../../../../factory/components/FactoryComponents.js';
import { getAlluser, switchOnOff } from '@/api/processManager'
const root = {}
export default root
root.name = 'processMonitorDevice';
root.data = {
	modal: {
		//是否显示添加编辑弹出框
		showModal: false,
		//modalTitle
		modalTitle: '新建',
		//当前弹出框类型, 0:DTO；1:报警器；2:传感器
		modalType: '0',
		//点击确定时调用的方法
		modalOk: null,
  },
  //弹出框绑定的数据
  modalData: {
    name: null,
    number: null,
    dangerInfoVo: {
      cellName: ""
    },
    physical: '',
    level: '',
    noticePerson: '',
    channleAddr: null
  },
  cellName: '',
  cellName2: '', //默认显示的区域
  noticePersonArr: [], // 通知人下拉框的数据
  selectPerson: [], // 已选择的通知人
	//表格数据
	table: {
		//dtu表格
		dtu: {
			title: [{
					title: '网关编码',
					key: 'gatewayNum'
				},
				{
					title: '网关名称',
					key: 'name'
        },
        {
          title: '供应商',
          slot: 'firm'
				},
				{
					title: '注册包指令',
					key: 'number'
				},
				{
					title: '网关类别',
					slot: 'netType'
				},
				{
					title: '网关型号',
					key: 'gatewayModel'
				},
				{
					title: '安装日期',
					slot: 'date'
				},
				{
					title: '采集频率（单位：秒）',
					key: 'samplingFrequency'
				},
				{
					title: '操作',
					slot: 'action',
					width: 150,
        },
			],
			data: [],
			//总页数
			total: 1,
			//每页多少行
			limit: 10,
			//当前页数
			thisPage: 1,
		},
		//报警器表格（前端报警器用的是alarm,但是在后台是用的是sensor代表为报警器）
		alarm: {
			title: [{
					title: '485地址',
					key: 'number'
				},
				{
					title: '报警主机名称',
					key: 'name'
				},
				{
					title: '网关名称',
					slot: 'dtu',
				},
				{
					title: '操作',
					slot: 'action',
					width: 150,
				}
			],
			data: [],
			//总页数
			total: 1,
			//每页多少行
			limit: 10,
			//当前页数
			thisPage: 1,
		},
		//传感器表格
		sensor: {
			title: [
				{
					title: '编码',
					key: 'number'
				},
				{
					title: '名称',
          key: 'channelName'
				},
				{
					title: '区域',
          key: 'dangerInfoName'
				},
				{
					title: '具体位置',
					key: 'location'
				},
        {
					title: '检测气体',
					key: 'checkGas',
				},
        {
          title: '单位',
          key: 'physical',
          width: 80
        },
				// {
				// 	title: '具体位置',
				// 	key: '',
				// },
				// {
				// 	title: '浓度第一级阈值',
				// 	key: 'highAlarmValue',
				// },
				// {
				// 	title: '浓度第二级阈值',
				// 	key: 'shortAlarmValue',
        // },
        {
          title: '高高报',
          key: 'highHighAlarmValue',
          width: 80
        },
        {
          title: '高报',
          key: 'highAlarmValue',
          width: 80
        },
        {
          title: '低报',
          key: 'shortAlarmValue',
          width: 80
        },
        {
          title: '低低报',
          key: 'shotShotAlarmValue',
          width: 80
        },
        {
          title: '运行状态',
          slot: 'isOk',
          width: 95,
        },
        {
          slot: 'switch',
          title: '上/下线',
          width: 85,
          align: 'center'
        },
				{
					title: '操作',
					slot: 'action',
					width: 150,
				}
			],
			data: [],
			//总页数
			total: 0,
			//每页多少行
			limit: 10,
			//当前页数
			thisPage: 1,
    },
  },
  // 存放报警器的数据
  alarmList: [],
  // 气体单位
  qtUnit: [
    { id: "0", name: 'PPM' },
    { id: "1", name: 'mg/m3' },
    { id: "2", name: '%VOL' },
    { id: "3", name: '%LEL' }
  ],
	//新增编辑报警器时，选择dtu时的数据
	dtuDataAll: {
		data:[],
	},
	//新增编辑传感器时，选择报警器时的数据
	alarmDataAll: {
		data:[],
	},
	//新增编辑传感器时，选择建筑时的数据
	buildDataAll: {
		data:[],
  },
  

  // 新建厂商时,选择厂商的下拉框
  chooseFirm: [
    { id: 1, name: '安福' },
    { id: 2, name: '恒瑞安' },
    { id: 3, name: '瀚达电子' },
    { id: 4, name: '利信万嘉' },
    { id: 5, name: '顺安电子' },
  ]
	
}
root.methods = {
	
	//点击了新增或者编辑按钮
	clickAddBtn: function(data){
    this.modal.showModal = true;
    this.selectPerson = []
		if(data){
			//如果是编辑状态,则初始化编辑的data
      this.modalData = {...data};
      // this.$set(this.modal, 'modalData', {...data})
      // console.log(this.modalData)
		}
		if(this.modal.modalType === '0'){
			//如果当前数据id不为null，则是编辑数据
			if(this.modalData.id){
				this.modal.modalTitle = '编辑DTU';
				this.modal.modalOk = this.operaDtu;
			}else{
				this.modal.modalTitle = '新建DTU';
				this.modal.modalOk = this.addDtu;
			}
			
		}
		if(this.modal.modalType === '1'){
			this.getDtu();
			//如果当前数据id不为null，则是编辑数据
			if(this.modalData.id){
				this.modal.modalTitle = '编辑报警器';
				this.modal.modalOk = this.operaAlarm;
			}else{
				this.modal.modalTitle = '新建报警器';
				this.modal.modalOk = this.addAlarm;
			}
		}
		if(this.modal.modalType === '2'){
			this.getAlarm(1);
			this.getAllBuild();
			//如果当前数据id不为null，则是编辑数据
			if(this.modalData.id){
				this.modal.modalTitle = '编辑传感器';
        this.modal.modalOk = this.operaSensor;
        this.componentsMoudel.startGet(`/channel/info/${this.modalData.id}`, {}, true).then(res => {
          this.modalData = {...res.body.data}
          let arr = res.body.data.noticePerson.split(',')
          for(let m in arr) {
            this.selectPerson.push(Number(arr[m]))
          }
          // this.selectPerson = 
        })
      }else{
        this.modal.modalTitle = "新增传感器"
        this.modal.modalOk = this.addSensor
      }
      this.cellName = this.modalData.dangerInfoId;
      if(this.modalData.noticePerson) {
        let arr = this.modalData.noticePerson.split(',')
        for(let i in arr) {
          this.selectPerson.push(parseInt(arr[i]))
        }
        // this.selectPerson = this.modalData.noticePerson.split(',')
        // console.log(this.selectPerson)
      }
		}
		
	},
	//点击了取消按钮
	modalCancel: function(){
		this.modal.showModal = false;
		this.modalData = {};
		this.modal.modalOk = null;
	},
	
	//弹出框点击确定
	modalOk: function(){
		this.modal.modalOk(this.modalData);
	},
	
	//新增dto
	addDtu: function(data){
		const that = this;
		this.componentsMoudel.startPost('/dtu/save', data, true).then(res => {
			that.modalCancel();
			that.getDtu(that.table.dtu.thisPage)
		})
	},
	
	//获取dto
	getDtu: function(page){
		if(page === undefined){
			const that = this;
			this.componentsMoudel.startPost('/dtu/list_all', {}, true).then(res => {
        that.dtuDataAll.data = res.body.data;
        that.$nextTick(() => {
          that.$set(that.table.dtu, 'total', res.body.cum)
        })
        // that.table.dtu.total = res.body.cum;
			})
		}else{
			const that = this;
			const data = {};
			data.curPage = page;
      data.limit = this.table.dtu.limit;
      data.isPage = 1
			this.componentsMoudel.startPost('/dtu/list_all', data, true).then(res => {
				that.table.dtu.data = res.body.data;
				that.table.dtu.total = res.body.cum;
				that.table.dtu.thisPage = res.body.page;
			})
		}
		
	},
	
	//编辑dto
	operaDtu: function(data){
		const that = this;
		this.componentsMoudel.startPost('/dtu/update', data, true).then(res => {
			that.modalCancel();
			that.getDtu(that.table.dtu.thisPage)
		})
	},
	//删除dto
	delDtu: function(data){
    const that = this;
    // console.log(data)
    this.$confirm(`删除 "${data.name}", 是否继续?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.componentsMoudel.startPost('/dtu/delete/'+data.id, null, true).then(res => {
        if(that.table.dtu.data.length <= 1 && that.table.dtu.thisPage > 1) {
          that.table.dtu.thisPage -= 1
        }
        that.getDtu(that.table.dtu.thisPage);
        this.$message.success('删除成功')
      })
    }).catch(() => {
      return
    });
	},
	
	
	//新增报警器
	addAlarm: function(data){
		const that = this;
		// if(data.channelNum % 2 !== 0 || data.channelNum <= 0){
		// 	this.$message({
		// 		message: '传感器数量必须大于0且必须为2的倍数',
		// 		type: 'error'
		// 	});
		// 	return;
    // }

    
    if(!this.isIntNum(data.number)) {
      this.$message.error('报警器地址请输入正整数')
      return
    } 
		this.componentsMoudel.startPost('/alarmDevice/save', data, true).then(res => {
			that.modalCancel();
			that.getAlarm(that.table.alarm.thisPage,1)
		})
	},
	
	//获取报警器
	getAlarm: function(page,status){
		if(page === undefined){
			const that = this;
			this.componentsMoudel.startPost('/alarmDevice/list_all', {}, true).then(res => {
        that.alarmDataAll.data = res.body.data;
        that.table.alarm.total = res.body.cum;
			})
		}else{
			const that = this;
			const data = {};
			data.curPage = page;
      data.limit = this.table.alarm.limit;
      data.isPage = status
			this.componentsMoudel.startPost('/alarmDevice/list_all', data, true).then(res => {
				that.table.alarm.data = res.body.data;
        that.table.alarm.total = res.body.cum;
        // console.log(res.body.cum)
        that.table.alarm.thisPage = res.body.page;
        that.alarmList = res.body.data
        // console.log(that.alarmList)
			})
		}
	},
	
	//编辑报警器
	operaAlarm: function(data){
    const that = this;
    if(!this.isIntNum(data.number)) {
      this.$message.error('报警器地址请输入正整数')
      return
    } 
		this.componentsMoudel.startPost('/alarmDevice/update', data, true).then(res => {
			that.modalCancel();
			that.getAlarm(that.table.alarm.thisPage,1)
		})
	},
	//删除报警器
	delAlarm: function(data){
    const that = this;
    // console.log(data)
    this.$confirm(`删除 "${data.name}", 是否继续?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.componentsMoudel.startPost('/alarmDevice/delete/'+data.id, null, true).then(res => {
        if(that.table.alarm.data.length <= 1 && that.table.alarm.thisPage > 1) {
          that.table.alarm.thisPage -= 1
        }
        that.getAlarm(that.table.alarm.thisPage,1);
        this.$message.success('删除成功')
      })
    }).catch(() => {
      return         
    });
	},
	
	//获取传感器
	getSensor: function(page){
    const that = this;
    that.table.sensor.thisPage = page;
		const data = {};
		data.curPage = page;
    data.limit = this.table.sensor.limit;
    data.isPage = 1
		// this.componentsMoudel.startPost('/channel/list_all', data, false).then(res => {
    this.componentsMoudel.startPost('/channel/listAllNew', data, false).then(res => {
			that.table.sensor.data = res.body.data;
			that.table.sensor.total = res.body.cum;
		})
	},
  
  // 选择区域时下拉框的事件
  spaceChange: function(val) {
    // console.log(val, typeof(val))
    this.$set(this.modalData, "dangerInfoId", val)
  },

  // 选择通知人的事件
  selectPersonChange: function(val) {
    // console.log(val)
    this.modalData.noticePerson = val.join(',')
    // console.log(this.modalData.noticePerson)
  },

	//获取所有区域
	getAllBuild: function() {
		const that = this;
		if(that.buildDataAll.data.length === 0){
			this.componentsMoudel.startGet('/dangerinfo/all_list', null, true).then(res => {
        that.buildDataAll.data = res.body.data;
			})
		}
	},
  
  
  // 新增传感器
  addSensor: function(data) {
    const that = this;
    if(!this.isIntNum(data.channleAddr)) {
      this.$message.error('报警器地址请输入正整数')
      return
    } 
    this.componentsMoudel.startPost('/channel/save', data, true).then(res => {
			that.modalCancel();
			that.getSensor(that.table.sensor.thisPage)
		})
  },

	//编辑传感器
	operaSensor: function(data){
    if(!this.isIntNum(data.channleAddr)) {
      this.$message.error('报警器地址请输入正整数')
      return
    }
		const that = this;
		this.componentsMoudel.startPost('/channel/update', data, true).then(res => {
			that.modalCancel();
			that.getSensor(that.table.sensor.thisPage)
		})
  },
  
  // 删除传感器
  deleteBtnCgq: function(data) {
    // console.log(data)
    this.$confirm(`删除 "${data.name}", 是否继续?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.componentsMoudel.startPost('/channel/delete/'+data.id, null, true).then(res => {
        if(this.table.sensor.data.length <= 1 && this.table.sensor.thisPage > 1) {
          this.table.sensor.thisPage -= 1
        }
        this.getSensor(this.table.sensor.thisPage);
        this.$message.success('删除成功')
      })
    }).catch(() => {
      return          
    });
  },

  // 传感器上下线状态
  switchOn(row) {
    // console.log(row)
    switchOnOff(row.id).then(res => {
      this.getSensor(this.table.sensor.thisPage)
    })
  },
	
	
	//tab页切换
	tabSwitch: function(name){
		this.modal.modalType = name;
		if(name === '0'){
			this.getDtu(1);
		}
		if(name === '1'){
      this.getAlarm(1,1);
		}
		if(name === '2'){
      this.getSensor(this.table.sensor.thisPage);
      this.getAlarm(1,0)
		}
  },
  
  // 正则正整数校验
  isIntNum(val) {
    let reg = /^[1-9]\d*$/
    let status = reg.test(val)
    return status
  }
}
root.mounted = function(){
  this.getDtu(1);
  getAlluser().then(res => {
    // console.log(res.body.data)
    this.noticePersonArr = res.body.data
  })
}

FactoryComponents.initComponent(root);
